import { render, staticRenderFns } from "./AllAudioCategoriesAffirmation.vue?vue&type=template&id=65d24206&scoped=true&"
import script from "./AllAudioCategoriesAffirmation.vue?vue&type=script&lang=js&"
export * from "./AllAudioCategoriesAffirmation.vue?vue&type=script&lang=js&"
import style0 from "./AllAudioCategoriesAffirmation.vue?vue&type=style&index=0&id=65d24206&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d24206",
  null
  
)

export default component.exports